import script from "./StickyBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./StickyBanner.vue?vue&type=script&setup=true&lang=ts"

import "./StickyBanner.vue?vue&type=style&index=0&id=07543c6a&lang=scss"

const __exports__ = script;

export default __exports__